// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2xkxV","header":"Messages_header__3IjNQ"};